import React from 'react'
import styled from 'styled-components'
import {injectIntl} from 'react-intl'
import Selector from 'components/Selector'
import Item from './Item'
import {rollupFilterRules} from 'utils/enums/rollup'

const FilterList = styled.div`
    margin-bottom: 20px;
`

const Empty = styled.div`
    height: 70px;
    align-items: center;
    padding: 0 20px;
    display: flex;
    border: none;
    margin: 0;
    box-shadow: 0 1px 3px 0 rgba(179, 216, 225, .5);
    background: #FFF;
`

class Filters extends React.Component {
    handleSelect = (data) => {
        const filters = [...this.props.filters]

        filters.push({
            fieldId: data.id,
            fieldType: data.type,
            rule: Object.values(rollupFilterRules[data.type])[0],
            valueMin: null,
            valueMax: null
        })

        this.props.changeFilters(filters)
    }

    changeRule = (value, name, type) => {
        const filters = [...this.props.filters]
        const el = {...filters.find(item => item.fieldId === name)}
        const index = filters.findIndex(item => item.fieldId === name)

        el.rule = value

        const conditions = rollupFilterRules[type]

        if ((conditions.empty && value === conditions.empty)) {
            el.valueMin = null
            el.valueMax = null
        }

        if (conditions.between && value !== conditions.between) {
            el.valueMax = null
        }

        filters.splice(index, 1, el)

        this.props.changeFilters(filters)
    }

    changeValue = (value, type, name) => {
        const filters = [...this.props.filters]
        const filter = {...filters.find(item => item.fieldId === name)}
        const index = filters.findIndex(item => item.fieldId === name)

        if (type === 'max') {
            filter.valueMax = value
        } else {
            filter.valueMin = value
        }

        filters.splice(index, 1, filter)

        this.props.changeFilters(filters)
    }

    deleteRule = (name) => {
        const filters = this.props.filters.filter(item => item.fieldId !== name)
        this.props.changeFilters(filters)
    }

    render() {
        const { intl, filterFields, filters } = this.props

        return (
            <React.Fragment>
                <FilterList>
                {!filters.length &&
                    <Empty>{intl.formatMessage({id: "filter.empty"})}</Empty>
                }
                {filters.map((item, index) =>
                    <Item
                        valueMin={item.valueMin}
                        valueMax={item.valueMax}
                        key={index}
                        type={item.fieldType}
                        title={item.pathName}
                        name={item.fieldId}
                        changeRule={this.changeRule}
                        rule={item.rule}
                        changeValue={this.changeValue}
                        options={this.props.options[item.field]}
                        deleteRule={this.deleteRule}
                    />
                )}
                </FilterList>
                <Selector
                    data={filterFields.filter(el =>
                        !filters.find(filter => filter.fieldId === el.id)).map(item => {
                            return {
                                name: item.pathName,
                                id: item.id,
                                type: item.type
                            }
                        }
                    )}
                    disabled={filters.length === filterFields.length}
                    handleSelect={this.handleSelect}
                    text='filter.add'
                />
            </React.Fragment>
        )
    }
}

export default injectIntl(Filters)
